import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LogOut, Terminal } from "lucide-react";

const linkClass = ({ isActive }) =>
    `font-mono uppercase tracking-[0.2em] text-xs transition-colors duration-150 ${
        isActive ? "text-phosphor-amber glow-amber" : "text-foreground/70 hover:text-phosphor-amber"
    }`;

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <header
            data-testid="site-navbar"
            className="sticky top-0 z-40 border-b border-border/70 bg-background/95 backdrop-blur-sm"
        >
            <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-10">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="flex items-center gap-3 group"
                >
                    <span className="grid h-9 w-9 place-items-center border border-phosphor-amber text-phosphor-amber">
                        <Terminal className="h-4 w-4" strokeWidth={2} />
                    </span>
                    <div className="leading-tight">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                            The Curated
                        </div>
                        <div className="font-serif text-xl text-foreground group-hover:text-phosphor-amber transition-colors">
                            Mainframe<span className="terminal-caret" />
                        </div>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    <NavLink to="/" end className={linkClass} data-testid="nav-gallery">
                        Gallery
                    </NavLink>
                    <NavLink to="/stats" className={linkClass} data-testid="nav-stats">
                        Statistics
                    </NavLink>
                    {user && user.role === "admin" && (
                        <NavLink to="/admin" className={linkClass} data-testid="nav-admin">
                            Admin
                        </NavLink>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user && user.id ? (
                        <>
                            <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                                {user.email}
                            </span>
                            <button
                                data-testid="nav-logout-btn"
                                onClick={async () => {
                                    await logout();
                                    navigate("/");
                                }}
                                className="flex items-center gap-2 border border-border px-3 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-foreground/80 hover:border-phosphor-amber hover:text-phosphor-amber transition-colors"
                            >
                                <LogOut className="h-3 w-3" />
                                Sign out
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                data-testid="nav-login-btn"
                                className="font-mono text-[10px] uppercase tracking-[0.2em] text-foreground/70 hover:text-phosphor-amber transition-colors"
                            >
                                Log in
                            </Link>
                            <Link
                                to="/register"
                                data-testid="nav-register-btn"
                                className="border border-phosphor-amber bg-phosphor-amber px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-background hover:bg-transparent hover:text-phosphor-amber transition-colors"
                            >
                                Curate ▸
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
